// extracted by mini-css-extract-plugin
export default {"button":"scizers-wt-components-form-item-styles-button","checkBox":"scizers-wt-components-form-item-styles-checkBox"};